export class Information {
    information_id: number;
    titel: string;
    txt: string;
    gueltig_von: Date;
    gueltig_bis: Date;
    vorname: string;
    nachname: string;
    informationstyp: number; // 1 tourenplan, 2 wawi
}
